export default "__VITE_ASSET__BOM4723I__"